import React from 'react';
import { isRouteErrorResponse, useRouteError } from 'react-router-dom';

import { ErrorFallback } from './ErrorBoundary';

export default function RouteErrorBoundary() {
	const routeError = useRouteError();
	const error = routeError instanceof Error ? routeError : undefined;
	const description = isRouteErrorResponse(routeError)
		? `${routeError.status} ${routeError.statusText}`
		: 'The requested page could not be displayed. Reload the portal to try again.';

	return <ErrorFallback title="Page unavailable" description={description} error={error} onRetry={() => window.location.reload()} fullHeight />;
}
